export enum EGstCategory {
  ZR = 'ZR',
  SR = 'SR',
  OS = 'OS',
}
